import { render, staticRenderFns } from "./SumupQuestionScoreRateList.vue?vue&type=template&id=4f8956f0&"
import script from "./SumupQuestionScoreRateList.vue?vue&type=script&lang=ts&"
export * from "./SumupQuestionScoreRateList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports